/*
  Event guide: https://support.google.com/analytics/answer/1033068#Anatomy
  Submitting events: https://developers.google.com/analytics/devguides/collection/gtagjs/events

  action: the doing part of the event "click", "play", "pause" or something to describe target of the event
  label: a specific identifier for the event, e.g. which nav item, or what video, what file, etc etc
  category: The group of events that is taking place.

  Note that it's not nessicary to await this function unles you specifically want to wait for the event to
  finish sending. The event will always be sent before the page unloads.
*/
async function trackGenericEvent(unParsedAction, unParsedCategory, unParsedLabel) {
  if (!window.gtag) {
    throw new Error("Gtag isn't loaded - make sure it's loaded before tracking events")
  }

  // we parse the tracking data so that it conforms to standard - all lower case
  const [action, category, label] = [unParsedAction, unParsedCategory, unParsedLabel].map(str => {
    if (str) {
      return str.trim().toLowerCase()
    }
  })

  return new Promise(resolve => {
    // if the envionment is dev DONT send data to google analytics. This is so that we don't pollute
    // our tracking with our testing or broken data while we work on a feature. Instead, just print to the
    // console
    if (PetRescue.env.environment === 'development') {
      console.info('Tracking event triggered', { category, label, action })
      return resolve()
    }

    // set a timeout to resolve in the event gtag fails to send the event. This way awaited events don't disrupt
    // the critical path.
    setTimeout(resolve, 500)

    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      event_callback: resolve,
    })
  })
}

export function createAnalyticsGroup(category) {
  return (action, label) => trackGenericEvent(action, category, label)
}

/*
  Purchasing tracking helpers
*/

// https://developers.google.com/analytics/devguides/collection/gtagjs/ecommerce
export function trackPurchase({ transaction_id, affiliation, currency, value, frequency }) {
  const gaPayload = { transaction_id, affiliation, currency, value }
  const fbPayload = { value, currency, frequency }

  // Don't trigger in dev so we don't pollute our analytics
  if (PetRescue.env.environment === 'development') {
    console.info('Payment tracking event triggered', gaPayload)
    return
  }

  window.gtag('event', 'purchase', gaPayload)
  if (window.fbq) window.fbq('track', 'Donate', fbPayload)
}
